export default __webpack_public_path__ + "static/swizec-social-bf94aef7dec71c7e9475a4107790e298.png";